import { withWindow } from '@shared/utils/withWindow';
import { config } from '@static/js/joy';

export const performFullPageRedirect = (path: string) => {
  withWindow(global => {
    global.location.href = global.location.origin + path;
  });
};

/**
 * Build a guest RSVP path with a `v=1` cache-bust query param.
 *
 * The RSVP deadline middleware may send a 302 redirect when the deadline is
 * closed. Without cache-busting, browsers can replay that cached redirect
 * even after the host extends the deadline. Appending `v=1` ensures the
 * browser treats the navigation as a fresh URL that bypasses any stale 302.
 */
export const buildRsvpPath = (eventHandle: string | undefined, existingSearch = ''): string => {
  const base = `/${eventHandle || ''}/rsvp`;
  const params = new URLSearchParams(existingSearch);
  params.set('v', '1');
  return `${base}?${params.toString()}`;
};

// Encode `prev` via searchParams to avoid a double-`?` when the path already contains a query string.
export const buildAuthUrl = (route: '/login' | '/signup', returnPath: string): string => {
  const url = new URL(route, config.clientUri);
  url.searchParams.set('prev', returnPath);
  return url.href;
};

export const buildReturnPath = (loc: { pathname: string; search: string; hash: string }): string => `${loc.pathname}${loc.search}${loc.hash}`;
